import {
  LocaleLanguages,
  localeLanguagesSchema,
} from "@companies/shared/types/locale-languages";
import {
  getValueAtPathFromLocale,
  LocaleOptions,
} from "@companies/shared/utils/locale";
import { useMemo } from "react";
import { create } from "zustand";

import en from "../locale/en";
import { Locale } from "../locale/locale.type";
import sv from "../locale/sv";
import { getItem, setItem } from "../services/local-storage";

const locales: { en: Locale; sv: Locale } = {
  en,
  sv,
};

export type LocalRef = string;

export const useLocale = create<{
  locale: Locale;
  currentLanguage: LocaleLanguages;
  currentLocaleName: string;
  setLocale: (locale: string) => void;
  get: (path: string, options?: LocaleOptions) => string;
}>((set, get) => {
  const currentLanguage = getItem<LocaleLanguages>(
    "current-language",
    localeLanguagesSchema,
    "en",
  );

  const getLocaleName = (language: LocaleLanguages): string => {
    switch (language) {
      case "sv":
        return "sv-SE";
      case "en":
      default:
        return "en-US";
    }
  };

  return {
    locale: locales[currentLanguage],
    currentLanguage,
    currentLocaleName: getLocaleName(currentLanguage),
    setLocale: (locale: LocaleLanguages) => {
      setItem("current-language", locale);
      set({
        currentLanguage: locale,
        locale: locales[locale],
        currentLocaleName: getLocaleName(locale),
      });
    },
    get: (path: string, options: LocaleOptions = {}) => {
      const { currentLanguage } = get();
      return getValueAtPathFromLocale(locales[currentLanguage], path, options);
    },
  };
});
